import { HttpClient } from '@angular/common/http';
import {
  EnvironmentProviders,
  importProvidersFrom,
  inject,
} from '@angular/core';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export function provideTranslate(): EnvironmentProviders {
  return importProvidersFrom(
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'en',
      useDefaultLang: true,
    })
  );
}

export function appTranslateInitializer() {
  return () => {
    const translate = inject(TranslateService);

    translate.setDefaultLang('en');

    return firstValueFrom(translate.use('en'));
  };
}
